import { INCREMENT_REQUEST_COUNTER_PO, INCREMENT_REQUEST_COUNTER_QUEUE, RESET_REQUEST_COUNTER_PO, RESET_REQUEST_COUNTER_QUEUE} from '../actions/actionTypes';

import RequestCounter from '../../models/RequestCounter';

const initialState: RequestCounter = { countPO: 0, countQueue: 0 };

export const counterRequestReducer = (state: RequestCounter = initialState, action: any) => {
  switch (action.type) {
    case INCREMENT_REQUEST_COUNTER_PO:
      const counterPO: number = state.countPO + 1;
      return {
        ...state,
        countPO: counterPO
      }; 
    case INCREMENT_REQUEST_COUNTER_QUEUE:
      const counterQueue: number = state.countQueue + 1;
      return {
        ...state,
        countQueue: counterQueue
      };
    case RESET_REQUEST_COUNTER_PO:
      return {
        ...state,
        countPO: 0
    };
    case RESET_REQUEST_COUNTER_QUEUE:
      return {
        ...state,
        countQueue: 0
      }
    default:
      return state;
  }
};
